import { WriteApiService } from '../services/write-api.service';
import { ContactModel } from '../models';

type GetContactListOptions<T = ContactModel> = {
  converter?: (data: T) => T;
};

/**
 * Acesso a participantes pela API.
 *
 * O Firestore esta fechado para o cliente (firestore.rules): toda leitura e
 * escrita passa pelo backend, que resolve o caminho da colecao a partir do
 * projectId e confere o acesso do usuario.
 */
class ContactRepository {
  static async getById(contactId: number, projectId: string): Promise<ContactModel | null> {
    return WriteApiService.getContact(projectId, contactId);
  }

  static async getList<T = ContactModel>(projectId: string, options?: GetContactListOptions<T>): Promise<T[]> {
    const contatos = (await WriteApiService.listAllContacts(projectId)) as T[];

    return options?.converter ? contatos.map(options.converter) : contatos;
  }

  static async count(projectId: string): Promise<number> {
    const { total } = await WriteApiService.countContacts(projectId);

    return total;
  }
}

export { ContactRepository };
export type { GetContactListOptions };
